import NotificationProvider from '@/common/containers/NotificationProvider/NotificationProvider';

export default NotificationProvider;
